<!-- 阻焊覆盖 -->
<template>
  <BaseFormItem
    class="cover"
    :label="fields.label"
    :labelTips="fields.labelTips"
    :labelTipsWidth="fields.labelTipsWidth"
  >
    <BaseRadioGroup v-model="val" @change="handleEmit">
      <el-radio-button
        v-for="item in options"
        :key="item.value"
        :label="item.value"
        :disabled="item.disabled"
      >{{ item.label }}</el-radio-button>
    </BaseRadioGroup>
    
    <div slot="labelTipsContent" class="cover__labelTipsContent">
      <ul>
        <li v-for="item in labelTipsContent" :key="item.title">
          <p class="cover__labelTipsContent__title">{{ item.title }}</p>
          <p class="cover__labelTipsContent__img"><img :src="item.img" width="104" /></p>
          <p class="cover__labelTipsContent__text">{{ item.text }}</p>
        </li>
      </ul>
      <p class="cover__labelTipsContent__otherTips">
        因gerber文件无法分清过孔和插件孔，若您的文件是gerber格式，我司一律按文件加工.
      </p>
    </div>
  </BaseFormItem>
</template>

<script>
import { getROGERSFields } from '@@/utils/getFields'
import { alertFieldsTips } from '@@/utils/alertFieldsTips'

export default {
  props: {
    value: {
      type: String,
      default: '过孔塞油墨'
    },
    // 返回修改初始化参数时，参数不进行关联变更
    initPcbParamsChange: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      val: this.value,
      labelTipsContent: [
        { title: '过孔盖油', img: require('@@/assets/img/pcb/label/cover_1.png'), text: '生产时使用连塞带印工艺，一次性将过孔和孔环覆盖阻焊油，过孔在过锡炉的时候不沾锡，少部分孔可能会透光或孔口发红现象，属于工艺正常现象。' },
        { title: '过孔开窗', img: require('@@/assets/img/pcb/label/cover_2.png'), text: '过孔和孔环均不覆盖阻焊油。' },
        { title: '过孔塞油墨', img: require('@@/assets/img/pcb/label/cover_3.png'), text: '生产时先用铝片将阻焊油墨塞进过孔里面，再整板印阻焊油，所有过孔都不会透光。' },
        { title: '过孔塞树脂+电镀填平', img: require('@@/assets/img/pcb/label/cover_4.png'), text: '生产时在过孔内塞树脂，孔口凸起树脂磨平后，再将孔口盖铜填平，可靠性更好，所有过孔都不会透光。价格较贵，交期会延长几天，请慎重选择。' },
      ]
    }
  },
  computed: {
    fields() {
      return getROGERSFields('cover')
    },
    options() {
      const { val, fields } = this
      const options = fields.options
      let disabledOptions = ['过孔盖油', '过孔开窗']

      // 如果当前项被禁用，选中第一个可选的选项
      if (disabledOptions.includes(val)) {
        this.changeVal(options.find(item => !disabledOptions.includes(item.value)).value)
      }
      
      return options.map(item => ({...item, disabled: disabledOptions.includes(item.value) }))
    }
  },
  watch: {
    value(newVal) {
      this.val = newVal
    },
  },
  methods: {
    handleEmit() {
      const { val, value } = this
      this.$emit('input', val)
      if (val != value) {
        this.$emit('change', val)
      }
    },
    changeVal(val) {
      if (this.initPcbParamsChange) return
      alertFieldsTips(this.fields.label)
      this.val = val
      this.handleEmit()
    }
  }
}
</script>

<style lang="scss" scoped>
.cover {
  .cover__tips {
    margin-top: 4px;
    line-height: 1.5;
    font-size: $--font-size-small;
    color: $--color-text-placeholder;
    span {
      color: $--color-warning;
    }
  }
}
.cover__labelTipsContent {
  width: 536px;
  font-size: 12px;
  >ul {
    display: flex;
    align-items: stretch;
    border-right: 1px solid #EBEEF5;
    border-bottom: 1px solid #EBEEF5;
    >li {
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
      width: 126px;
      &:last-child {
        width: 161px;
      }
      >p {
        padding: 10px;
        border-top: 1px solid #EBEEF5;
        border-left: 1px solid #EBEEF5;
      }
      .cover__labelTipsContent__title {
        padding: 6px 10px;
        text-align: center;
        background-color: #F5F7FA;
      }
      .cover__labelTipsContent__img {
        text-align: center;
      }
      .cover__labelTipsContent__text {
        flex: 1;
      }
    }
  }
  .cover__labelTipsContent__otherTips {
    padding: 6px 10px;
    font-size: 12px;
    border: 1px solid #EBEEF5;
    border-top: 0;
    background-color: #F5F7FA;
  }
}
</style>